import React from 'react';
import '../styles/ProjectCard.css';

const ProjectCard = ({ title, description, image, link, tags, index }) => {
  return (
    <div
      className="project-card"
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="project-image">
        <div className="image-overlay">
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            View Project →
          </a>
        </div>
        {typeof image === 'string' && image.startsWith('linear-gradient') ? (
          <div className="project-placeholder" style={{ background: image }}>
            <div className="placeholder-icon">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>
        ) : (
          <img src={image} alt={title} className="project-image-img" />
        )}
      </div>

      <div className="project-info">
        <h3 className="project-title">{title}</h3>
        <p className="project-description">{description}</p>

        {tags && tags.length > 0 && (
          <div className="project-tags">
            {tags.map((tag, idx) => (
              <span key={idx} className="tag">{tag}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
